import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';
import { TourAnchorDirective } from './directives/tour-anchor.directive';
import { TourOverlayComponent } from './components/tour-overlay/tour-overlay.component';
import { TourModalComponent } from './components/tour-modal/tour-modal.component';
import { TourStepListComponent } from './components/tour-step-list/tour-step-list.component';

@NgModule({
  declarations: [
    TourOverlayComponent,
    TourModalComponent,
    TourStepListComponent,
    TourAnchorDirective,
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatRippleModule,
  ],
  exports: [
    TourOverlayComponent,
    TourAnchorDirective,
  ],
})
export class TourCoreModule {}
